import { Link } from "@tanstack/react-router";
import { Mail } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-electric flex items-center justify-center">
                <span className="text-electric-foreground font-bold text-sm">A</span>
              </div>
              <span className="font-display font-bold text-xl tracking-tight text-gradient-electric">angle-shop.com</span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-sm">
              Vêtements et chaussures de marque. Style premium, livraison rapide.
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-sm mb-4 text-foreground">Liens utiles</h2>
            <ul className="space-y-1">
              <li><Link to="/catalog" className="text-sm text-muted-foreground hover:text-foreground transition-colors py-1 min-h-[24px] inline-flex items-center">Collection</Link></li>
              <li><Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors py-1 min-h-[24px] inline-flex items-center">CGV</Link></li>
              <li><Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-foreground transition-colors py-1 min-h-[24px] inline-flex items-center">Confidentialité</Link></li>
              <li><Link to="/support" className="text-sm text-muted-foreground hover:text-foreground transition-colors py-1 min-h-[24px] inline-flex items-center">Support</Link></li>
            </ul>
          </div>

          <div>
            <h2 className="font-semibold text-sm mb-4 text-foreground">Newsletter</h2>
            <p className="text-sm text-muted-foreground mb-4">Recevez nos offres exclusives</p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="votre@email.com"
                className="flex-1 px-3 py-2 rounded-lg bg-background border border-border text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-electric"
              />
              <button aria-label="S'inscrire à la newsletter" className="p-2 rounded-lg bg-gradient-electric hover:opacity-90 transition-opacity">
                <Mail className="w-4 h-4 text-electric-foreground" />
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 text-center">
          <p className="text-sm text-muted-foreground">© 2026 angle-shop.com. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
